import React, { Component } from 'react';
import { connect } from 'react-redux';
import { saveDocumentsDetail, getDocumentGroupService } from 'src/services/documents.service';
import { transformFormValues } from 'src/helpers';
import documentsActions from '../state/documentsActions';
import DocumentInfoPres from 'src/ui/features/Documents/presentational/DocumentInfoPres';
import withSnackbar from 'src/utils/Notifications/withSnackbar';
import intl from 'react-intl-universal';
import { isEYProSelector, isApplicantSelector, isCorpClientSelector } from 'src/ui/features/Login/state/loginReselect';
import { openDocumentsTab } from 'src/ui/features/Documents/state/documentsActions';

export class DocumentInfoContainer extends Component {
  state = {
    formDetails: {},
    casePhases: {},
    isEditable: false,

    showCancelEditlModal: false,
    showDeleteModal: false,

    accessCorporateClient: false,
    accessEmployee: false,
    accessEyProfessional: false,
    isSaveDisabled: true,
    isSaving: false,
  };

  componentDidMount() {
    const { documentid, caseDocumentTypeId } = this.props.match.params;
    this.props.getDetails(documentid, caseDocumentTypeId);
    this.formValues = null;
  }

  setDocumentAccess = () => {
    const { corporateClient, employee, eyProfessional } = this.props.docState.documentDetail.documentAccess;

    this.setState({
      accessCorporateClient: corporateClient,
      accessEmployee: employee,
      accessEyProfessional: eyProfessional,
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.docState !== prevProps.docState) {
      if (this.props.docState.documentDetail.hasOwnProperty('documentInformation')) {
        this.setDocumentAccess();
      }
    }
  }

  componentWillUnmount() {
    this.props.dehydrateDetails();
  }

  handleEdit = () => {
    this.setState({ isEditable: true, isSaveDisabled: true });
  };

  toggleModal = status => {
    this.setState({
      showCancelEditlModal: status,
      showDeleteModal: status,
    });
  };

  toggleEditModal = status => {
    this.setState({
      showCancelEditlModal: status,
    });
  };

  handleFormChange = data => {
    this.formData = data;
    this.setState({ isSaveDisabled: !data.isFormComplete });
  };

  handleCancel = () => {
    this.setState({
      showCancelEditlModal: false,
      showDeleteModal: false,
      isEditable: false,
    });

    this.setDocumentAccess();
  };

  handleDelete = target => {
    this.setState({
      showDeleteModal: true,
    });
  };

  onDocumentAccessChanged = value => {
    this.setState({
      [value]: !this.state[value],
    });
  };

  onConfirmDelete = () => {
    const { documentid, caseDocumentTypeId } = this.props.match.params;
    const { deleteDocument, history } = this.props;

    deleteDocument(
      documentid,
      caseDocumentTypeId,
      'Document Deleted',
      () => {
        this.handleCancel();
        history.goBack();
        this.props.openDocumentsTab();
      },
      () => {},
    );
  };

  handleSave = async () => {
    if (this.state.isSaving) {
      return;
    }

    this.setState({ isSaving: true });

    try {
      // the "save" request requires pretty much all the key/vals from the getCaseDetail request.
      // this is just a quick & easy way to build the request by ignoring some keys
      const {
        clientId,
        documentTypeId,
        applicantId,
        documentName,
        documentId,
        documentType,
      } = this.props.docState.documentDetail.documentInformation;
      const { activeCaseManagerId } = this.props;
      const { formValues } = this.formData;
      const transformed = transformFormValues(formValues);
      const { accessCorporateClient, accessEmployee, accessEyProfessional } = this.state;
      const { caseManagerId, caseDocumentTypeId, documentid } = this.props.match.params;
      const access = {
        corporateClient: accessCorporateClient,
        employee: accessEmployee,
        eyProfessional: accessEyProfessional,
      };

      const caseChat = JSON.parse(sessionStorage.getItem('caseChat'));
      const headerDetailsObject = sessionStorage.getItem('headerDetails');
      const headerDetails = headerDetailsObject ? JSON.parse(headerDetailsObject) : {};
      const overViewId = !caseChat ? headerDetails.overViewId || 0 : 0;
      // if overview id matches with url param then case is not assigned yet and pass casemanager as 0
      const overviewCaseManagerId = caseManagerId == overViewId ? 0 : caseManagerId;
      const data = {
        clientId,
        caseDocumentTypeId: caseDocumentTypeId ? parseInt(this.props.match.params.caseDocumentTypeId, 10) : 0,
        documentTypeId,
        applicantId,
        documentName,
        documentId,
        documentType,
        documentAccess: access,
        caseManagerId: caseChat ? activeCaseManagerId || caseManagerId : overviewCaseManagerId,
        overViewId: overViewId,
        ...transformed,
      };

      const response = await getDocumentGroupService();

      if (response && response.success) {
        // const result = response.data.filter(document => {
        //   return document.groupDescription === 'Taxchat EY Pro Documents';
        // });

        const { documentGroupId } = this.props.match.params;
        data.documentGroupId = documentGroupId;
        const docResult = await saveDocumentsDetail({
          ...data,
          applicantProfileKey: data.applicantId,
        });

        if (docResult && docResult.success) {
          await this.props.getDetails(documentid, caseDocumentTypeId, () => {});
          this.setState({ isEditable: false });
          this.props.enqueueSnackbar(intl.get('documents.documentDetails.messages.successMessage'), { variant: 'success' });
        } else {
          if (docResult && docResult.error) {
            const { message = 'Error ' } = docResult.error;
            this.props.enqueueSnackbar(message, { variant: 'error' });
          }
        }
      }
    } finally {
      this.setState({ isSaving: false });
    }
  };

  render() {
    return (
      <DocumentInfoPres
        documentId={this.props.match.params.documentid}
        docState={this.props.docState}
        documentDetail={this.props.documentDetail}
        onFormChange={this.handleFormChange}
        showCancelEditlModal={this.state.showCancelEditlModal}
        showDeleteModal={this.state.showDeleteModal}
        onEdit={this.handleEdit}
        onCancel={this.toggleEditModal.bind(null, true)}
        onCancelModal={this.handleCancel}
        onConfirmModal={this.toggleModal.bind(null, false)}
        onConfirmDeleteModal={this.onConfirmDelete}
        onSave={this.handleSave}
        isEditable={this.state.isEditable}
        isSaveDisabled={this.state.isSaveDisabled}
        isSaving={this.state.isSaving}
        onDelete={this.handleDelete}
        getDocument={this.props.getDocument}
        onDocumentAccessChanged={this.onDocumentAccessChanged}
        isEYPro={this.props.isEYPro}
        isApplicant={this.props.isApplicant}
        isCorpClient={this.props.isCorpClient}
        accessCorporateClient={this.state.accessCorporateClient}
        accessEmployee={this.state.accessEmployee}
        accessEyProfessional={this.state.accessEyProfessional}
      />
    );
  }
}

const mapStateToProps = state => ({
  docState: state.documents,
  isEYPro: isEYProSelector(state),
  isApplicant: isApplicantSelector(state),
  isCorpClient: isCorpClientSelector(state),
  activeCaseManagerId: state.documents.activeCaseManagerId,
});

const mapDispatchToProps = {
  getDetails: documentsActions.getDocumentDetails,
  getDocument: documentsActions.getDocument,
  getDocumentFromGlobalMenu: documentsActions.getlinkedCase,
  deleteDocument: documentsActions.deleteDocument,
  dehydrateDetails: documentsActions.deHydrateDocumentDetails,
  openDocumentsTab,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(DocumentInfoContainer));
